export default __webpack_public_path__ + "static/section2-8f7cda2feba065741a528ca9d6be5f4c.png";